
export default function TableHead({children}) {
    return (
        <thead className="text-light bg-dark">
            {children}
        </thead>
    );
}
